// The myUMBC search box owns the input now (see #search-box); the Google CSE
// is results-only. On load, run the full Google search for the current query
// so the results render without a Google-owned input box.
// window.__gcse || (window.__gcse = {});
// window.__gcse.initializationCallback = function () {
//   var container = document.getElementById("search");
//   var query = container?.dataset?.query;
//   if (!query) return;

//   var searchElement = window.google?.search?.cse?.element?.getElement("myumbc-searchresults");
//   if (searchElement) searchElement.execute(query);
// };


// Index suggestions as you type — mirrors the header UI search box. Suggestions
// come from the local index (/search/suggest); the full Google results
// only load on submit (Enter or the arrow button), which navigates to /search.

// var refinementsToggleContainer = document.getElementById("refinements");

// (function() {
//   refinementsToggleContainer?.addEventListener("click", function(evt) {
//     var link = evt.target.closest("a[data-refinement]");
//     if (!link) return;
//     evt.preventDefault();
//     var container = document.getElementById("search");
//     if (!container) return;
//     var currentRefinement = container.dataset.refinement;
//     var selectedRefinement = link.dataset.refinement;
//     // if (currentRefinement === selectedRefinement) return;
//     var element = window.google?.search?.cse?.element?.getElement("myumbc-searchresults");
//     if (!element) return;
//     var hash = new URLSearchParams(window.location.hash.slice(1));
//     if (selectedRefinement === "all") {
//       hash.delete("gsc.ref");
//     } else {
//       hash.set("gsc.ref", 'more:' + selectedRefinement);
//     }
//     container.dataset.refinement = selectedRefinement;
//     history.replaceState(null, null, '#' + hash.toString());
//     var query = element.getInputQuery();
//     // var cleanQuery = element.getInputQuery()?.replace(/\bmore:\S+/g, '')?.trim();
//     // if (!cleanQuery) return;
//     // var newQuery = cleanQuery + ' more:' + selectedRefinement;
//     // element.clearAllResults();
//     // element.execute(query);
//   });
// })();

document.addEventListener("DOMContentLoaded", function () {
  var form = document.getElementById("search-box");
  if (!form) return;
  var input = form.querySelector(".search-box__input");
  var clear = form.querySelector(".search-box__clear");
  var results = form.querySelector(".search-box__suggestions");
  var suggestUrl = form.dataset.suggestUrl;
  var DEBOUNCE_MS = 180;

  var debounce = null;
  var xhr = null;
  var cache = {};

  function currentQuery() { return input.value.replace(/\s+/g, " ").trim(); }

  function suggestionLinks() { return Array.prototype.slice.call(results.querySelectorAll(".menu__item")); }

  function showSuggestions(html, forQuery) {
    if (currentQuery() !== forQuery) return; // stale render, query moved on
    results.innerHTML = html;
  }

  // Close the dropdown without clearing the query — drops any pending request
  // and empties the list (the :empty rule hides it). Reopens on next input.
  function closeSuggestions() {
    cancel();
    results.innerHTML = "";
  }

  // Move selection by focusing items — same as the header UI search box, so the
  // highlight is the shared .menu__item:focus style. Down from the input focuses
  // the first item; Up from the first item returns to the input. Enter then
  // follows the focused link natively (no full search).
  function moveSelection(direction) {
    var links = suggestionLinks();
    if (links.length === 0) return;
    var current = links.indexOf(document.activeElement);
    var next = current + direction;
    if (next < 0) {
      input.focus();
    } else if (next < links.length) {
      links[next].focus();
    } else {
      links[links.length - 1].focus();
    }
  }

  function cancel() {
    clearTimeout(debounce);
    debounce = null;
    if (xhr) { xhr.abort(); xhr = null; }
  }

  function load() {
    var query = currentQuery();
    if (query === "") return;

    var cached = cache[query];
    if (cached != null) { showSuggestions(cached, query); return; }

    if (xhr) xhr.abort();
    var request = new XMLHttpRequest();
    xhr = request;
    request.open("GET", suggestUrl + "?" + new URLSearchParams({ query: query }));
    request.setRequestHeader("X-Requested-With", "XMLHttpRequest");
    request.onload = function () {
      if (request.status === 200) {
        cache[query] = request.responseText;
        showSuggestions(request.responseText, query);
      }
      if (xhr === request) xhr = null;
    };
    request.send();
  }

  form.classList.toggle("search-box--query", currentQuery() !== "");

  input.addEventListener("input", function () {
    form.classList.toggle("search-box--query", currentQuery() !== "");
    if (currentQuery() === "") { cancel(); results.innerHTML = ""; return; }
    if (cache[currentQuery()] != null) { cancel(); load(); return; }
    clearTimeout(debounce);
    debounce = setTimeout(load, DEBOUNCE_MS);
  });

  // Arrow keys move focus through suggestions; Enter then follows the focused
  // link (full search only happens when focus is in the input). Listen on the
  // form so the handler keeps firing once focus moves off the input.
  form.addEventListener("keydown", function (evt) {
    if (evt.key === "ArrowDown") {
      if (suggestionLinks().length === 0) return;
      evt.preventDefault();
      moveSelection(1);
    } else if (evt.key === "ArrowUp") {
      if (suggestionLinks().length === 0) return;
      evt.preventDefault();
      moveSelection(-1);
    } else if (evt.key === "Escape") {
      closeSuggestions();
      input.focus();
    }
  });

  // Clicking outside the search box closes the dropdown (keeps the query).
  document.addEventListener("click", function (evt) {
    if (!form.contains(evt.target)) closeSuggestions();
  });

  clear.addEventListener("click", function () {
    input.value = "";
    closeSuggestions();
    form.classList.remove("search-box--query");
    input.focus();
  });
});

// Handle toggling of the "Show Search Answers" preference. The card collapses
// immediately (optimistic UI) while the preference saves in the background;
// on failure it reverts so the toggle doesn't drift from the saved value.
document.addEventListener("DOMContentLoaded", function () {
  var cardEl = document.getElementById("search-answer-card");
  if (!cardEl) return;
  function handlePreferenceToggle(evt) {
    var toggle = evt.target.closest(".toggle-switch") || (evt.target.classList.contains("search-answer-preference-checkbox") ? evt.target.closest(".search-answer-preference-label").querySelector(".toggle-switch") : null);
    if (!toggle) return;
    if (toggle.classList.contains("toggle-switch--processing")) return;
    toggle.classList.add("toggle-switch--processing");
    var currentlyEnabled = !cardEl.classList.contains("search-answer-card--collapsed");
    cardEl.classList.toggle("search-answer-card--collapsed", currentlyEnabled);
    var form = cardEl.querySelector("#search-answer-preference-form");
    var xhr = new XMLHttpRequest();
    xhr.open(form.method, form.action);
    xhr.setRequestHeader("X-Requested-With", "XMLHttpRequest");
    xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
    var csrfToken = document.querySelector("meta[name=csrf-token]");
    if (csrfToken) xhr.setRequestHeader("X-CSRF-Token", csrfToken.getAttribute("content"));
    xhr.onload = function () {
      if (xhr.status !== 200) {
        cardEl.classList.toggle("search-answer-card--collapsed", !currentlyEnabled);
      } else if (!currentlyEnabled && window.__searchLoadAnswerOnEnable) {
        // Wait for the preference save to land before fetching — the answer
        // endpoint re-checks the live preference server-side, so fetching in
        // parallel with the save can race and see the stale (off) value.
        window.__searchLoadAnswerOnEnable();
      }
      toggle.classList.remove("toggle-switch--processing");
    };
    xhr.onerror = function () {
      cardEl.classList.toggle("search-answer-card--collapsed", !currentlyEnabled);
      toggle.classList.remove("toggle-switch--processing");
    };
    xhr.send("opt_in=" + (currentlyEnabled ? "0" : "1"));
  }
  cardEl.querySelector(".search-answer-card__header").addEventListener("click", handlePreferenceToggle);
  cardEl.querySelector(".search-answer-card__header").addEventListener("change", handlePreferenceToggle);
});

// Load the answer asynchronously — either after the page loads (so the Google
// CSE can render results without waiting for it) or when the user flips
// answers on for a query that was already answerable but not yet fetched
// (see the preference-toggle handler above). Also handles rating feedback and
// expanding the answer text if it's truncated.
(function () {
  var loadStarted = false;

  function loadAnswer() {
    if (loadStarted) return;
    var container = document.getElementById("search");
    var answer_container = document.getElementById("search-answer");
    var query = container?.dataset?.query;
    if (!container || !query || !answer_container) return;
    loadStarted = true;

    var titleEl = document.querySelector(".search-answer-card__title");
    if (titleEl) {
      var pawIcon = document.querySelector(".search-answer-loading .icon--loading-paw") || document.querySelector(".icon--loading-paw");
      titleEl.innerHTML = "";
      if (pawIcon) titleEl.appendChild(pawIcon.cloneNode(true));
      titleEl.appendChild(document.createTextNode("Fetching answer…"));
    }

    var url = answer_container.dataset.url + "?query=" + encodeURIComponent(query);
    var FADE_MS = 120;
    fetch(url, { headers: { "X-Requested-With": "XMLHttpRequest" } })
      .then(function (r) {
        if (!r.ok) throw new Error("Search answer request failed: " + r.status);
        return r.text();
      })
      .then(function (html) {
        // Cross-fade: fade the skeleton out, then swap in the real answer and
        // fade it in, rather than an instant content swap.
        answer_container.classList.add("search-answer-container--fading");
        return new Promise(function (resolve) {
          setTimeout(function () { resolve(html); }, FADE_MS);
        });
      })
      .then(function (html) {
        answer_container.innerHTML = html;
        answer_container.classList.remove("search-answer-container--fading");
        answer_container.classList.add("search-answer-container--loaded");
        var answer = answer_container.querySelector(".ai-answer");
        var empty = answer_container.querySelector(".ai-answer-empty");
        if (titleEl) titleEl.textContent = (answer && answer.dataset.question) || (empty && empty.dataset.question) || "Answer";
        var text = answer && answer.querySelector(".answer-text");
        if (answer && text) {
          // Only keep the truncated state (and the "Show more" button) when
          // there's at least ~2 lines of genuinely hidden content. The mask
          // fade already previews the bottom half of the truncated box, so
          // a smaller overage reveals almost nothing when expanded and reads
          // as if the button did nothing.
          var lineHeight = parseFloat(getComputedStyle(text).lineHeight) || 1;
          var MIN_HIDDEN_LINES = 2;
          var hiddenHeight = text.scrollHeight - text.clientHeight;
          if (hiddenHeight < lineHeight * MIN_HIDDEN_LINES) {
            answer.classList.remove("ai-answer--truncated");
          }
        }
        var readMore = answer && answer.querySelector(".answer-read-more");
        if (readMore) {
          readMore.addEventListener("click", function () {
            answer.classList.remove("ai-answer--truncated");
            readMore.setAttribute("aria-expanded", "true");
            readMore.style.display = "none";
          });
        }
        if (answer) {
          answer.addEventListener("click", function (evt) {
            var link = evt.target.closest(".answer-feedback__link--rate");
            if (!link || link.classList.contains("answer-feedback__link--clicked")) return;
            evt.preventDefault();
            link.classList.add("answer-feedback__link--clicked");
            var url = link.dataset.url;
            if (!url) return;
            var showNoReasons = link.dataset.showNoReasons !== undefined;
            var xhr = new XMLHttpRequest();
            xhr.open("POST", url);
            xhr.setRequestHeader("X-Requested-With", "XMLHttpRequest");
            var csrfToken = document.querySelector("meta[name=csrf-token]");
            if (csrfToken) xhr.setRequestHeader("X-CSRF-Token", csrfToken.getAttribute("content"));
            xhr.onload = function () {
              if (xhr.status === 200) {
                answer.classList.remove("search--feedback-no-reasons");
                answer.classList.add(showNoReasons ? "search--feedback-no-reasons" : "search--feedback-completed");
              }
            };
            xhr.send();
          });
        }
      })
      .catch(function () {
        // Answer wasn't available after all (e.g. the preference was turned
        // off in another tab while this fetch was in flight) — drop back to
        // the pre-fetch title and clear loadStarted so a later retrigger
        // (e.g. re-enabling the preference) can try again.
        loadStarted = false;
        answer_container.classList.remove("search-answer-container--fading");
        answer_container.innerHTML = "";
        if (titleEl) titleEl.textContent = "Answer";
      });
  }

  document.addEventListener("DOMContentLoaded", function () {
    var cardEl = document.getElementById("search-answer-card");
    // Skip the eager load if the card starts collapsed (answers off) — the
    // server would reject the fetch anyway (see My4::SearchController#answer),
    // since it re-checks the preference at fetch time. loadAnswerOnEnable,
    // set on window by the toggle handler above, runs it once the user turns
    // answers on instead.
    if (cardEl && cardEl.classList.contains("search-answer-card--collapsed")) return;
    loadAnswer();
  });

  window.__searchLoadAnswerOnEnable = loadAnswer;
})();

// Click tracking for the Google CSE results — those links are rendered by
// Google's own JS after the page loads, replacing our .gcse-searchresults-only
// placeholder with its own gsc-*/gs-* markup, so we can't attach a [data-track]
// attribute to each result server-side (see tracking.js for that generic path).
// The signed message instead lives on the stable #search container as
// data-results-track — a distinct attribute from tracking.js's [data-track] so
// its generic handler doesn't also match every click inside #search (that would
// resolve the "link" as #search itself and log the whole page as the label).
// This listener resolves url/label from whichever Google result link was
// actually clicked, mirroring tracking.js's beacon shape. Unlike a suggestion
// click, no separate Search.query beacon is needed here — the query was
// already logged server-side when My4::SearchController#index rendered this
// page, so firing another would double-count the search.
document.addEventListener("click", function (evt) {
  var container = evt.target.closest("#search[data-results-track]");
  if (!container) return;
  var resultsArea = evt.target.closest(".gsc-control-cse");
  if (!resultsArea) return;
  var link = evt.target.closest("a[href]");
  if (!link) return;

  var params = new URLSearchParams();
  params.set("from", window.location.pathname);

  // The "Search '<query>' on Google" link below pagination carries the raw
  // query and CSE config in its URL (google.com/search?q=...&cx=...), which
  // is different on every search and useless for grouping. Log it as one
  // fixed target instead of the literal URL.
  if (evt.target.closest(".gcsc-more-maybe-branding-root")) {
    params.set("url", "https://www.google.com/search");
    params.set("label", "Search on Google");
  } else {
    try {
      var url = new URL(link.getAttribute("href"), window.location.href);
      // Always the full origin + path (never scheme-relative), so the
      // logged url is complete whether it's on this origin, another UMBC
      // subdomain, or an external site.
      params.set("url", url.origin + url.pathname + url.search);
    } catch {
      params.set("url", link.getAttribute("href"));
    }

    var label = (link.textContent || "").replace(/\s+/g, " ").trim();
    if (label) params.set("label", label);
  }

  navigator.sendBeacon("/_action/" + encodeURIComponent(container.dataset.resultsTrack) + "?" + params);
}, true);